import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterBy' })
export class FilterByPipe implements PipeTransform {
  transform(items: any[], filter: { [key: string]: any }): any[] {
    return items.filter(item => Object.keys(filter).every(key => item[key] === filter[key]));
  }
}
